import React, { useState, useEffect } from "react";

const CountdownTimer = ({ endTime, label = "Time Remaining:" }) => {
  const [timeLeft, setTimeLeft] = useState("--:--:--");

  useEffect(() => {
    console.log("Received endTime:", endTime);
    console.log("EndTime type:", typeof endTime);

    if (!endTime) {
      console.log("No endTime provided");
      setTimeLeft("--:--:--");
      return;
    }

    const calculateTimeLeft = () => {
      try {
        const now = new Date().getTime();
        // Handle if endTime is already a Date object
        const end =
          endTime instanceof Date
            ? endTime.getTime()
            : new Date(endTime).getTime();

        // console.log("Parsed end time:", new Date(end).toLocaleString());

        if (isNaN(end)) {
          console.error("Invalid end time format:", endTime);
          return "--:--:--";
        }

        const difference = end - now;

        if (difference <= 0) {
          return "00:00:00";
        }

        const hours = Math.floor(difference / (1000 * 60 * 60));
        const minutes = Math.floor(
          (difference % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        return `${hours.toString().padStart(2, "0")}:${minutes
          .toString()
          .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
      } catch (error) {
        console.error("Error calculating time left:", error);
        return "--:--:--";
      }
    };

    // Initial calculation
    setTimeLeft(calculateTimeLeft());

    const timer = setInterval(() => {
      const newTimeLeft = calculateTimeLeft();
      setTimeLeft(newTimeLeft);

      // Log every minute for debugging
      if (newTimeLeft.endsWith(":00")) {
        console.log("Current time left:", newTimeLeft);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [endTime]);

  return (
    <div className="countdown-timer">
      <span className="timer-label">{label}</span>
      <span className="timer-value">{timeLeft}</span>
    </div>
  );
};

export default CountdownTimer;
